import useStyles from "../../styles";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { fetchExamDate, fetchExamByDate, fetchExamByBetweenDate } from "../../service/services";
import { toast, ToastContainer } from "react-toastify";

function ReportHeaderNotPreview({ exportApi, setLoaderOpen, type = null,isDualDate=false }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [examDate, setExamDate] = useState([]);
  const [selectedExamDate, setSelectedExamDate] = useState("");
 const [selectedExamDateTo, setSelectedExamDateTo] = useState();

  const [exam, setExam] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");

  const [fileURL, setFileURL] = useState("");

  const handleExamDateChange = (event) => {
    setSelectedExamDate(event.target.value);
    setSelectedExam("");
  };
  const handleExamDateToChange = (e)=>{
    setSelectedExamDateTo(e.target.value)
    setSelectedExam("");
  }

  const handleExamChange = (event) => {
    setSelectedExam(event.target.value);
  };

  const fetchExamDateAPi = async () => {
    try {
      const response = await fetchExamDate();
      setExamDate(response.exams);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    fetchExamDateAPi();
  }, []);

  const fetchExamAPi = async (a,b=null) => {
    // console.log(a,b)
    try {
     const response = isDualDate? await fetchExamByBetweenDate(selectedExamDate,selectedExamDateTo):  await fetchExamByDate(selectedExamDate);
      if (response.success) {
        // setExam(response.exams);
        console.log("fetchExamByBetweenDate",response)
        if (type === "section") {
          const data = response.exams.filter(
            (exam) => exam.exam_template !== "default"
          );
          setExam(data);
        } else {
          setExam(response.exams);
        }
      }
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    if (selectedExamDate) {
      isDualDate ?fetchExamAPi(selectedExamDate,selectedExamDateTo) :fetchExamAPi(selectedExamDate);
    }
  }, [selectedExamDate,selectedExamDateTo]);

  const handleExportClick = async () => {
    console.log("selectedExam", selectedExam);
    try {
      if (!selectedExam) {
        toast.error("Export file is not available for this.");
        return;
      }

      setLoaderOpen(true); // show loader before API call

      // ✅ use exportApi instead of Report2Api
      const response = await exportApi(selectedExam,selectedExamDate,selectedExamDateTo);

      if (response.success === false) {
        setLoaderOpen(false);
        toast.warning(response.message || "Failed to download the CSV file.");
        return;
      }

      if (response.success) {
        setFileURL(response.file_url);
        window.open(response.file_url, "_blank");
        toast.success("CSV has been downloaded successfully.");
        setLoaderOpen(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while fetching the data.";
      toast.error(errorMessage);
      setLoaderOpen(false);
    }
  };

  return (
    <>
      <div
        className={` ${classes.w80} ${classes.border1999} ${classes.bgwhite} ${classes.m0auto} ${classes.mt1} ${classes.borderradius6px} ${classes.inputpadding} ${classes.dflex} ${classes.flexdirectioncolumn}`}
      >
        {/* ✅ Grey Header */}
        <div
          style={{
            backgroundColor: "#f5f5f5", // light grey
            padding: "10px 16px",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: "16px",
              fontWeight: 600,
              color: "#333",
              fontFamily: "Outfit, sans-serif",
            }}
          >
            Report Option
          </h3>
        </div>

        {/* ✅ Body Content */}
        <div
          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.alignitemscenter} ${classes.w100}`}
        >
          {/* Exam Date */}
          <div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.w90}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.mb0_5} ${classes.fontsize1}`}
            >
             {isDualDate?"Exam Date From": "Exam Date"}
            </FormLabel>
            {/* <Select
              id="examdate"
              value={selectedExamDate}
              onChange={handleExamDateChange}
              displayEmpty
              className={classes.selectEmpty}
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Date</em>
              </MenuItem>
              {examDate?.map((st) => (
                <MenuItem key={st.start_date} value={st.start_date}>
                  {st?.start_date}
                </MenuItem>
              ))}
            </Select> */}
            <TextField
              type="date"
              variant="outlined"
              required
              value={selectedExamDate}
              onChange={handleExamDateChange}
              placeholder="Select Date"
            />
          </div>

          {isDualDate&&( <div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.w90}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.mb0_5} ${classes.fontsize1}`}
            >
             Exam Date To
            </FormLabel>
            {/* <Select
              id="examdate"
              value={selectedExamDate}
              onChange={handleExamDateChange}
              displayEmpty
              className={classes.selectEmpty}
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Date</em>
              </MenuItem>
              {examDate?.map((st) => (
                <MenuItem key={st.start_date} value={st.start_date}>
                  {st?.start_date}
                </MenuItem>
              ))}
            </Select> */}
            <TextField
              type="date"
              variant="outlined"
              required
              value={selectedExamDateTo}
              onChange={handleExamDateToChange}
              placeholder="Select Date"
            />
          </div>)
          }

          {/* Exam Selection */}
          <div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.w90}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.mb0_5} ${classes.fontfamilyoutfit} ${classes.fontsize1}`}
            >
              Exam
            </FormLabel>
            <Select
              id="exam"
              value={selectedExam}
              onChange={handleExamChange}
              displayEmpty
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Exam</em>
              </MenuItem>
              {exam?.map((data, index) => (
                <MenuItem value={data.id} key={index}>
                {data.exam_code} -  {data.exam_name}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div
            className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.mt1} ${classes.mb1} ${classes.w90}`}
          >
            {" "}
            <Button
              variant="contained"
              color="primary"
              className={`${classes.bluebtn} ${classes.alignSelfEnd}`}
              onClick={handleExportClick}
            >
              Run Report
            </Button>
          </div>
          {/* Run Report Button */}
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
export default ReportHeaderNotPreview;
